<script>
    import { format } from 'svelte-i18n';
    import { removeTags } from '../../js/utils.js';
    import { handleAssetsUpsert } from './assets.state.svelte.js';

    let { selected_rows, closeEditModal } = $props();

    let is_loading = $state(false);

    let formData = {};
    let formIsSubmitted = false;
    let APIerror = null;

    async function handleSubmit(event) {
        if (event) event.preventDefault();

        formIsSubmitted = true;
        APIerror = null;

        if (selected_rows.length > 100) {
            is_loading = false; // FIX: typo 'loading' to 'is_loading'
            APIerror = $format("notifications.max_100");
            return;
        }

        let data = [];
        is_loading = true;

        for (let [idx, asset] of Object.entries(selected_rows)) {
            if (!formData.description) formData.description = "";
            // FIX: actually apply the imported removeTags function!
            asset.description = removeTags(formData.description);
            data.push(asset);
        }

        closeEditModal();
        let response = await handleAssetsUpsert(data);

        formIsSubmitted = false;
        APIerror = null;
        is_loading = false;
        formData.description = "";
    }

    function handleCloseModal() {
        formIsSubmitted = false;
        closeEditModal(); // FIX: Ensure the modal actually closes when this runs
    }

    const handleKeydown = event => {
        if (event.key == "Escape") {
            handleCloseModal();
        }
    };
</script>

<!-- FIX: Svelte 5 uses onkeydown without the colon -->
<svelte:window onkeydown={handleKeydown} />

<form role="form" novalidate onsubmit={handleSubmit}>
    <div class="card">
        <div class="card-body">
            <div class="mb-3">
                <label for="description">{$format("form.fields.description")}</label>
                <input
                    type="text"
                    class="form-control t-input-source-code-description"
                    id="assetAddDescription"
                    name="description"
                    placeholder={$format("form.fields.description")}
                    bind:value={formData.description}
                />
            </div>
            <div class="alert alert-warning">
                <span for="name">{$format("form.helpers.massive_edit_helper")}</span>
            </div>

            <!-- FIX: Added HTML to actually display the >100 row error to the user -->
            {#if APIerror}
                <div class="mt-3 text-danger" style="font-size: 80%;">
                    {APIerror}
                </div>
            {/if}
        </div>

        {#if !is_loading}
            <div class="card-footer">
                <button
                    id="assetAddSubmit"
                    type="submit"
                    class="btn btn-primary t-submit-source-code-btn"
                >
                    {$format("buttons.save")}
                </button>

                <button
                    type="button"
                    class="btn btn-default"
                    onclick={handleCloseModal}
                    data-bs-dismiss="modal"
                >
                    {$format("buttons.cancel")}
                </button>
            </div>
        {:else}
            <div class="overlay">
                <i class="fas fa-2x fa-sync-alt fa-spin"></i>
            </div>
        {/if}
    </div>
</form>

<style>
    .alert.alert-warning {
        color: #856404;
        background-color: #fff3cd;
    }
</style>